const ConsoleHelper = (data, obj) => {
  if (process.env.NODE_ENV === "production") return
  /* eslint-disable no-console */
  if (obj !== undefined) console.log(data, obj)
  else console.log(data)
}

export default ConsoleHelper
